import { AuthAxios } from "../../global-config/HttpConfig";
import { ApiURIs } from "../../global-config/ApiList";

export default {
  getDashboardSummary() {
    return AuthAxios.get(ApiURIs.GetAdminDashboard);
  }
};
